// Domaines à effet : des domaines d'un rôle qui donnent un droit dans Deepflow (miroir de
// backend/app/services/reserved_domains.py). Si un rôle porte « Roadmap » et que son focus vise un projet, seuls ses
// titulaires sur ce projet modifient la roadmap ; sans titulaire, tout le monde garde la main.

export const RESERVED_DOMAINS = [
  {
    key: 'roadmap',
    label: 'Roadmap du projet',
    effect: "Seuls les titulaires créent, déplacent ou suppriment les itérations et jalons du projet, avec un motif gardé dans l'historique. Les sprints restent à l'équipe.",
  },
  {
    key: 'budget',
    label: 'Budgets des itérations',
    effect: "Seuls les titulaires fixent les prévisions de CA, d'heures et d'achats des itérations, avec un motif gardé dans l'historique.",
  },
  {
    key: 'facturabilite',
    label: 'Facturabilité',
    effect: "Seuls les titulaires décident si une itération est facturable ; Nexus leur pose la question en fin d'itération si rien n'est décidé.",
  },
  {
    key: 'facturation',
    label: 'Émission des factures',
    effect: "Les titulaires sont prévenus quand une itération facturable se termine, pour émettre la facture.",
  },
];

export const RESERVED_DOMAIN_BY_KEY = Object.fromEntries(RESERVED_DOMAINS.map((d) => [d.key, d]));

export const reservedDomainLabel = (key) => RESERVED_DOMAIN_BY_KEY[key]?.label || key;
